import {Types} from 'mongoose';
import {StateCodes} from '@/enums/StateCodes.enum';

/** Where the responsible QM person of a Bundesland comes from */
export enum QualityManagementResolutionSource {
    /** Assignee of the QualityManagementTeacherList containing the state */
    QUALITY_MANAGEMENT_LIST = 'qualityManagementList',
    /** Backup of the list (assignee inactive) */
    BACKUP = 'backup',
    /** Fallback: default supervisor of the state (Employee.isDefaultSupervisorForStates) */
    DEFAULT_SUPERVISOR = 'defaultSupervisor',
    /** Nobody (active) is responsible */
    NONE = 'none',
}

/** Responsible QM person of a Bundesland (QM list first, default supervisor as fallback) */
export interface QualityManagementResolutionResponseDto {
    state: StateCodes;
    source: QualityManagementResolutionSource;
    /** QualityManagementTeacherList, if source is qualityManagementList */
    list?: Types.ObjectId;
    /** Active LoginUser of the responsible person (receives to-dos) */
    loginUser?: Types.ObjectId;
    /** Employee of the responsible person */
    employee?: Types.ObjectId;
    firstName?: string;
    lastName?: string;
    /** Mail of the LoginUser (e.g. reply-to of parent mails) */
    mail?: string;
}

/** One row per Bundesland for the QM responsibility overview */
export interface QualityManagementStateOverviewItemDto {
    state: StateCodes;
    list?: {
        _id: Types.ObjectId;
        assignee: Types.ObjectId;
        assigneeName?: string;
        assigneeActive: boolean;
        /** Optional backup (Vertretung) */
        backup?: Types.ObjectId;
        backupName?: string;
        backupActive?: boolean;
        /** "Ansprechpartner für Lehrkräfte" (only with read on the field teacherContact) */
        teacherContact?: QualityManagementTeacherContact;
    };
    defaultSupervisor?: {
        _id: Types.ObjectId;
        firstName: string;
        lastName: string;
    };
    /** Who would receive a to-do today */
    effective: QualityManagementResolutionSource;
}

/** Business contact of a QM responsibility shown to teachers / applicants (never private profile data) */
export type QualityManagementTeacherContact = {
    phone?: string;
    mail?: string;
    officeHours?: string;
    topics?: string;
    hiddenStates?: StateCodes[];
};
